import { motion } from 'framer-motion';

const CHAPTERS = [
  {
    num: '01',
    title: 'Born of the Hills',
    body: 'Every draw begins in Gangtok, under lights that never blink. Golden Raja is not a game of chance alone — it is a daily ritual, broadcast from the heart of Sikkim.',
    img: 'https://images.unsplash.com/photo-1611583027838-515a1087afdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxnb2xkJTIwbmVja2xhY2UlMjBzcG90bGlnaHR8ZW58MHx8fHwxNzg2MTY3Mzg1fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Pendant under a spotlight',
  },
  {
    num: '02',
    title: 'Four Fires Daily',
    body: 'Morning blue, noon red, evening green, night purple. Each show carries its own colour, its own temper, its own faithful crowd. The wheel never sleeps for long.',
    img: 'https://images.unsplash.com/photo-1782988112531-a189b256440e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnb2xkJTIwamV3ZWxyeSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjE2NzM4NXww&ixlib=rb-4.1.0&q=85',
    alt: 'Rings glowing on embers',
  },
  {
    num: '03',
    title: 'One Golden Moment',
    body: 'A letter. Five numbers. Thirty seconds of silence across a thousand homes. Then — for someone — everything changes. That is the moment we build, four times a day.',
    img: 'https://images.unsplash.com/photo-1569397288884-4d43d6738fbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxnb2xkJTIwbmVja2xhY2UlMjBzcG90bGlnaHR8ZW58MHx8fHwxNzg2MTY3Mzg1fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Gold pendant necklace',
  },
];

export function Manifesto() {
  return (
    <section className="bg-[#050505] px-6 py-28 md:px-16 lg:px-24" data-testid="manifesto-section">
      <div className="mx-auto max-w-6xl">
        <motion.p
          className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          The manifesto
        </motion.p>

        <div className="mt-20 space-y-32">
          {CHAPTERS.map((ch, i) => (
            <motion.article
              key={ch.num}
              className={`grid items-center gap-12 lg:grid-cols-2 ${
                i % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''
              }`}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`manifesto-chapter-${ch.num}`}
            >
              <div>
                <span className="font-serif-lux block text-8xl font-light leading-none text-[#D4AF37] opacity-80 lg:text-9xl">
                  {ch.num}
                </span>
                <h3 className="font-serif-lux mt-6 text-4xl font-medium text-[#F5F5F5] lg:text-5xl">
                  {ch.title}
                </h3>
                <p className="mt-6 max-w-md text-base leading-relaxed text-[#A3A3A3]">{ch.body}</p>
              </div>
              <div className="group relative overflow-hidden">
                <div
                  className="pointer-events-none absolute inset-0 z-10"
                  style={{ background: 'radial-gradient(ellipse 70% 60% at 50% 40%, rgba(212,175,55,0.12), transparent 70%)' }}
                />
                <motion.img
                  src={ch.img}
                  alt={ch.alt}
                  className="aspect-[4/3] w-full object-cover brightness-75 transition-[filter,transform] duration-700 group-hover:scale-105 group-hover:brightness-100"
                  initial={{ scale: 1.2, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true, margin: '-100px' }}
                  transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
